module.exports = __webpack_public_path__ + "img/img-9b8f03.png";